/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { EmailRecipientRestService } from '@gh/builder-shared-data';
import { DictionaryService, InitViewService } from '@gh/common-shared';
import { Observable } from 'rxjs';
import { EmailRecipient, EmailRecipientList, emailRecipientToDto } from './email-recipients.model';

@Injectable()
export class EmailRecipientListBusinessService implements InitViewService {

  constructor(private restService: EmailRecipientRestService,
              private dictionaries: DictionaryService) {
  }

  initView(route: ActivatedRouteSnapshot): any {
    return {
      recipients: this.get(),
      emailScheduledTaskDict: this.dictionaries.get('SCHEDULED_TASKS_AND_INTERNAL_EMAILS'),
    };
  }

  get(): Observable<EmailRecipient[]> {
    return this.restService.get();
  }

  save(recipientList: EmailRecipient[]): Observable<EmailRecipientList> {
    return this.restService.save(recipientList.map(emailRecipientToDto));
  }
}
